import { createProfileApiDetails } from '../../constants/server.constants';
import gateway from '../../middlewares/axios/gateway';

const createProfileService = async (name, bio, country, profileImage, tags) => {
  const response = await gateway.post(createProfileApiDetails.path, {
    name, bio, profileImage, country, tags,
  });

  const { data, error } = response.data;

  return { data, error };
};

export default createProfileService;
